var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-dialer-common-page",
    {
      staticClass: "app-dialer-main-page",
      attrs: { "show-header": false, "is-loading": _vm.isLoading },
    },
    [
      _c("app-dialer-call-card-info", {
        attrs: {
          agent: _vm.agent,
          contact: _vm.contact,
          avatar: _vm.avatar,
          identifier: _vm.identifier,
          members: _vm.members,
          "show-info-button": !!_vm.description,
          "is-info-button-active": _vm.isInfoButtonActive,
          size: "mobile",
        },
        on: {
          "toggle-info": function ($event) {
            _vm.isInfoButtonActive = !_vm.isInfoButtonActive
          },
          "toggle-members": function ($event) {
            return _vm.$emit("toggle-members-page")
          },
        },
      }),
      _vm._v(" "),
      !_vm.isInfoButtonActive
        ? _c("app-dialer-call-status", {
            attrs: {
              "is-connecting": _vm.isConnecting,
              "is-in-progress": _vm.isInProgress,
              timestamp: _vm.timestamp,
              "session-id": _vm.sessionId,
              size: "mobile",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isInfoButtonActive
        ? _c("div", {
            staticClass: "info",
            domProps: { innerHTML: _vm._s(_vm.descriptionText) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("app-dialer-call-controls", {
        attrs: {
          "is-on-hold": _vm.isOnHold,
          "is-muted": _vm.isMuted,
          "is-put-on-hold-action-loading": _vm.isPutOnHoldActionLoading,
          "is-hang-up-action-loading": _vm.isHangUpActionLoading,
          "is-keypad-active": _vm.isKeypadActive,
          "is-invite-button-active": _vm.isInviteButtonActive,
          "is-transfer-button-active": _vm.isTransferButtonActive,
          "is-connecting": _vm.isConnecting,
          "has-keypad-button": _vm.hasKeypadButton,
          "has-invite-button": _vm.hasInviteButton,
          "has-transfer-button": _vm.hasTransferButton,
          "has-hold-button": _vm.hasHoldButton,
          "has-mute-button": _vm.hasMuteButton,
          "has-contact-member-on-call": _vm.hasContactMemberOnCall,
          size: "mobile",
        },
        on: {
          "toggle-keypad": function ($event) {
            return _vm.$emit("toggle-keypad")
          },
          "toggle-invite": function ($event) {
            return _vm.$emit("toggle-invite-page")
          },
          "toggle-transfer": function ($event) {
            return _vm.$emit("toggle-transfer-page")
          },
          "put-on-hold": function ($event) {
            return _vm.$emit("put-on-hold")
          },
          "mute-self": function ($event) {
            return _vm.$emit("mute-self")
          },
          "hang-up": function ($event) {
            return _vm.$emit("hang-up")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }